export default {
  'llm.callLogs.source': '執行來源',
  'llm.callLogs.officialSource': '官方服務',
  'llm.callLogs.tenantSource': '租戶自有模型',
  'llm.callLogs.localSource': '本地其他服務',
  'llm.callLogs.syncPending':
    '官方資料尚未同步完成或暫不可用；以下為已儲存記錄',
  'llm.callLogs.lastSynced': '官方資料同步時間',
  'llm.callLogs.officialUnavailable': '官方本文暫不可用，請稍後重試',
  'llm.callLogs.app': '應用',
  'llm.callLogs.scene': '場景',
  'llm.callLogs.caller': '呼叫者',
  'llm.callLogs.resource': '資源識別碼',
  'llm.callLogs.running': '執行中',
  'llm.callLogs.cancelled': '已取消',
  'llm.callLogs.unknown': '結果未知',
  'llm.callLogs.notProvided': '未提供',
  'llm.callLogs.estimated': '估算',
  'llm.callLogs.serviceType': '服務類型',
  'llm.callLogs.actions': '操作',
  'llm.callLogs.details': '呼叫詳情',
  'llm.callLogs.viewDetails': '查看詳情',
  'llm.callLogs.detailFailed': '載入詳情失敗',
  'llm.callLogs.complete': '完整',
  'llm.callLogs.truncated': '已截斷',
  'llm.callLogs.notCaptured': '未擷取',
  'llm.callLogs.expired': '已過期',
  'llm.callLogs.expiredBody': '本文已超過 30 天保留期',
  'llm.callLogs.retry': '重試',
  'llm.callLogs.incomplete': '呼叫未完整結束，以下為已擷取內容',
  'llm.callLogs.status': '狀態',
  'llm.callLogs.entryPoint': '呼叫入口',
  'llm.callLogs.startedAt': '開始時間',
  'llm.callLogs.endedAt': '結束時間',
  'llm.callLogs.duration': '總耗時',
  'llm.callLogs.firstResponse': '首回應耗時',
  'llm.callLogs.upstreamId': '上游 Request ID',
  'llm.callLogs.streaming': '串流呼叫',
  'llm.callLogs.yes': '是',
  'llm.callLogs.no': '否',
  'llm.callLogs.requestBody': '請求本文',
  'llm.callLogs.responseBody': '回應本文',
  'llm.callLogs.usage': '用量與費用',
  'llm.callLogs.inputTokens': '輸入 Token',
  'llm.callLogs.outputTokens': '輸出 Token',
  'llm.callLogs.totalTokens': '總 Token',
  'llm.callLogs.cacheReadTokens': '快取讀取 Token',
  'llm.callLogs.cacheWriteTokens': '快取寫入 Token',
  'llm.callLogs.cacheWrite1hTokens': '1 小時快取寫入 Token',
  'llm.callLogs.reasoningTokens': '推理 Token',
  'llm.callLogs.usageSource': '用量來源',
  'llm.callLogs.meter': '計量',
  'llm.callLogs.cost': '費用',
  'llm.callLogs.settlement': '結算金額',
  'llm.callLogs.errorsAndAttempts': '錯誤與嘗試',
  'llm.callLogs.errorCode': '錯誤碼',
  'llm.callLogs.failedStage': '失敗階段',
  'llm.callLogs.errorMessage': '錯誤訊息',
  'llm.callLogs.related': '關聯呼叫',
  'llm.callLogs.modelService': '模型',
  'llm.callLogs.digitalHuman': '數位人',
  'llm.callLogs.loadFailed': '載入呼叫日誌失敗，請重試',
  'llm.callLogs.requestIdHint': '輸入完整 Request ID，精確比對',
  'llm.callLogs.scope': '檢視範圍',
  'llm.callLogs.modelCode': '輸入模型編碼',
  'llm.callLogs.sceneCode': '輸入場景編碼',
  'llm.callLogs.reset': '重設',
  'llm.callLogs.search': '查詢',
  'llm.callLogs.collapse': '收起進階搜尋',
  'llm.callLogs.advanced': '進階搜尋',
  'llm.callLogs.retentionHint': '預設搜尋全部保留日誌；多個條件須同時符合。',
  'pages.navigation.items.modelCallLogs': '平台呼叫日誌',
  'llm.callLogs.officialLogs': '平台呼叫日誌',
  'llm.callLogs.tenant': '租戶',
  'llm.callLogs.refresh': '重新整理',
  'pages.navigation.items.aiScenes': '應用場景',
  'pages.navigation.items.modelPolicies': '執行策略',
  'pages.navigation.items.modelCircuits': '熔斷管理',

  'menu.centers.aiModels': 'AI模型',
  'pages.navigation.items.modelAccess': '模型接入',
  'pages.navigation.items.modelUsage': '平台整體用量',
  'pages.navigation.items.modelTenantUsage': '租戶用量管理',

  'menu.centers.workspace': '首頁',
  'menu.centers.applications': '應用',
  'menu.centers.capabilities': '服務',
  'menu.centers.markets': '市場',
  'menu.centers.resources': '維運',
  'menu.centers.commercial': '銷售',
  'menu.centers.management': '租戶',
  'menu.centers.settings': '設定',
  'menu.centers.resourceOverview': '資源概覽',
  'pages.navigation.mainNavigation': '主導覽',
  'pages.navigation.skipToContent': '跳到主要內容',
  'pages.navigation.resizeSidebar': '調整側欄寬度',
  'pages.navigation.items.appMarket': '應用市場',
  'pages.navigation.items.skillMarketplace': 'Skill 市場',
  'pages.navigation.items.mcpMarketplace': 'MCP 市場',
  'pages.navigation.items.pluginMarketplace': '插件市場',
  'pages.navigation.items.workspaceOverview': '工作台概覽',
  'pages.navigation.items.agentApps': '智慧體管理',
  'pages.navigation.items.models': '模型廣場',
  'pages.navigation.items.events': '事件引擎',
  'pages.navigation.items.mcp': 'MCP 服務',
  'pages.navigation.items.resourceOverview': '資源概覽',
  'pages.navigation.items.clusters': '叢集管理',
  'pages.navigation.items.storage': '應用儲存',
  'pages.navigation.items.knowledge': '知識庫',
  'pages.navigation.items.dataSources': '資料來源',
  'pages.navigation.items.applicationManagement': '應用管理',
  'pages.navigation.items.applications': '業務應用',
  'pages.navigation.items.pluginApplications': '外掛應用',
  'pages.navigation.items.applicationFeedback': '應用回饋',
  'pages.navigation.items.externalPublication': '外部應用上架',
  'pages.navigation.items.publicationReview': '應用上架審核',
  'pages.navigation.items.taxonomies': '分類法管理',
  'pages.navigation.items.aiServices': 'AI服務',
  'pages.navigation.items.digitalHumanMarket': '數位人',
  'pages.navigation.items.digitalHumanMarketplace': '數位人市場',
  'pages.navigation.items.mcpMarket': 'MCP',
  'pages.navigation.items.skillMarket': 'Skills',
  'pages.navigation.items.products': '統一商品目錄',
  'pages.navigation.items.packages': '方案管理',
  'pages.navigation.items.entitlements': '租戶權益',
  'pages.navigation.items.platformTenants': '租戶管理',
  'pages.navigation.items.platformUsers': '使用者管理',
  'pages.navigation.items.platformPermissions': '平台權限',
  'pages.navigation.items.platformSettings': '平台設定',
  'pages.navigation.items.orders': '付款訂單',
  'pages.navigation.items.members': '成員管理',
  'pages.navigation.items.departments': '部門管理',
  'pages.navigation.items.roles': '權限管理',
  'pages.navigation.items.auditLog': '稽核紀錄',
  'menu.centers.appStore': '部署範本',
  'menu.centers.deployments': '我的部署',
  'pages.navigation.items.appStore': '部署範本',
  'pages.navigation.items.deployments': '我的部署',
  'menu.centers.images': '映像倉庫',
  'pages.navigation.items.images': '映像倉庫',
};
